import { isAuthorEnv } from '../../../../scripts/utils/env-utils.js';
import { PLACEHOLDER_IMAGE_PATH } from '../product-tour.constants.js';
import { sanitizeEdsUrl } from './common.js';

/**
 * Formats and sanitizes image paths
 * @param {string} sourcePath - The URL to format
 * @returns {string} Formatted and sanitized image path
 */
export default function formatImagePath(sourcePath) {
  if (!sourcePath) {
    return PLACEHOLDER_IMAGE_PATH;
  } // Return placeholder image path

  // Helper function to handle path formatting
  const formatPath = (path) => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return isAuthorEnv()
      ? normalizedPath.replaceAll(/\/([a-z]{2})-([a-z]{2})\//g, '/$1_$2/')
      : sanitizeEdsUrl(normalizedPath);
  };

  try {
    // Handle both absolute and relative URLs uniformly
    const urlObj = new URL(sourcePath, window.location.origin);
    return formatPath(urlObj.pathname);
  } catch (urlError) {
    // If URL parsing fails, treat as relative path
    console.warn('URL parsing failed, treating as relative path:', urlError); // NOSONAR
    return PLACEHOLDER_IMAGE_PATH;
  }
}
